import { Typography } from 'antd'
import { Transaction, Transactionv2 } from '../../models/transaction'
import { theme } from 'theme'
import { formatStartMethodDisplay } from 'helpers/formatStartMethodDisplay'
import { renderFormatMessage } from 'helpers/intl'

interface props {
  transaction: Transaction | Transactionv2
}

const ellipsisValue = (value: string): JSX.Element | string => {
  if (value.length < 10) {
    return value
  }
  return (
    <Typography.Text style={{ color: theme.colors.softBlack, width: 70 }} ellipsis={{ tooltip: value }}>
      {value}
    </Typography.Text>
  )
}

const TitleAndSubtitle: React.FC<props> = ({ transaction }) => {
  const isV2 = 'username' in transaction

  const userName = isV2 ? (transaction as Transactionv2)?.username : (transaction as Transaction)?.user?.name
  return (
    <div className={!!userName ? 'flex-and-gap-below' : ''}>
      <p style={{ marginBottom: 0 }}>{(userName || '')?.trim().length ? ellipsisValue(userName) : '-'}</p>
      <span className="opacity-06 paragraph-04-light">
        {renderFormatMessage(
          `dashboard.transactionsPage.advancedSearch.startMethod.${transaction.startMethod.toLowerCase()}`,
          formatStartMethodDisplay(transaction.startMethod),
        )}
      </span>
    </div>
  )
}

export default TitleAndSubtitle
